function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import styles from './dropdown.less';
import closeDropdown from '../common/closeDropdown';
export var CategoryDropdown = function CategoryDropdown(_ref) {
  var selectedCategory = _ref.selectedCategory,
    onCategorySelected = _ref.onCategorySelected,
    displayClass = _ref.displayClass,
    hidden = _ref.hidden;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDropDown = _useState2[0],
    setShowDropdown = _useState2[1];
  var sortDropDownRef = useRef(null);
  var _closeDropdown = closeDropdown(sortDropDownRef, setShowDropdown),
    handleDropdown = _closeDropdown.handleDropdown;
  if (hidden) {
    return null;
  }
  useEffect(function () {
    return handleDropdown(showDropDown);
  }, [showDropDown]);
  var toggleDropdown = function toggleDropdown(event) {
    event === null || event === void 0 || event.preventDefault();
    setShowDropdown(!showDropDown);
  };
  var onSelected = function onSelected(category) {
    toggleDropdown();
    onCategorySelected(category);
  };
  var displayedLabel = function displayedLabel(label) {
    if (!label.includes('/')) {
      return label;
    }
    if (label.includes('/')) {
      return label.split('/').map(function (part, index, array) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, part, index !== array.length - 1 && '/', "\u200B");
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: sortDropDownRef,
    className: "grid-item margin-right-m ".concat(displayClass, " ").concat(styles.container)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleDropdown,
    className: "select absolute-reference ".concat(styles.selectButton),
    "data-testid": "categories-button"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, selectedCategory.label), /*#__PURE__*/React.createElement("span", {
    className: "is24-icon-chevron-down ".concat(styles.chevron)
  })), showDropDown && /*#__PURE__*/React.createElement("div", {
    className: styles.dropdown
  }, realtorCategories.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.value,
      className: "".concat(styles.entry, " ").concat(selectedCategory === option ? styles.selected : ''),
      onClick: function onClick() {
        return onSelected(option);
      },
      "data-testid": "realtor-category"
    }, displayedLabel(option.label));
  })));
};
export var realtorCategories = [{
  label: 'Immobilienanbieter',
  value: 'ANBIETER'
}, {
  label: 'Gewerbemakler',
  value: 'GEWERBEMAKLER'
}, {
  label: 'Bauträger',
  value: 'BAUTRAGER'
}, {
  label: 'Fertighaus/Massivhaushersteller',
  value: 'FERTIGHAUS'
}, {
  label: 'Wohnungsunternehmen',
  value: 'WOHNUNGSUNTERNEHMEN'
}, {
  label: 'Hausverwaltung',
  value: 'VERWALTUNG'
}, {
  label: 'Umzugsunternehmen',
  value: 'UMZUG'
}, {
  label: 'Finanzierungsanbieter',
  value: 'BAUFI'
}];